
import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';
import { Bell, Maximize, Minimize } from 'lucide-react';
import logo from './images/logo.jpeg';
import PriceAlertPopup from './pages/alert_notification_pop_up.js'
import { useNavigate } from 'react-router-dom';
import SearchComponent from './pages/search_stock.js';

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate(); // Add this import: import { useNavigate } from 'react-router-dom';
  const [activeHeader, setActiveHeader] = useState(null);
  const [activeSubheader, setActiveSubheader] = useState(null);
  const [showAlertPopup, setShowAlertPopup] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);

  // const callHeaderAPI = async () => {
  //   try {
  //     const response = await fetch('https://live1.finstrats.com/intrvl_hl_data');
  //     console.log('Header API Response:', response.data);
  //   } catch (error) {
  //     console.error('Error calling Header API:', error);
  //   }
  // };

  // useEffect(() => {
  //   callHeaderAPI();
  // }, []);

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };
    document.addEventListener('fullscreenchange', handleFullscreenChange);
    return () => document.removeEventListener('fullscreenchange', handleFullscreenChange);
  }, []);

  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().catch((err) => {
        console.error(`Error attempting to enable fullscreen: ${err.message}`);
      });
    } else {
      document.exitFullscreen();
    }
  };

  const mainNavItems = [
    {
      name: 'Heat Map',
      to: '/sector_heatmap',
      subheader: [
        { name: 'Industry', to: '/sector_heatmap' },
        { name: 'Industry Rank', to: '/sector_rank_change' },
        { name: 'Stock Rank', to: '/stock_rank_change' },
      ],
    },
    {
      name: 'Sector',
      to: '/sector_momentum',
    },
    {
      name: 'Stocks',
      to: '/',
      subheader: [
        { name: 'Top Gainers Losers', to: '/' },
        { name: 'Result', to: '/result_analysis' },
        { name: 'Intraday Base', to: '/intraday_base' },
        { name: 'G&L Details', to: '/gainersdetails' },
        { name: '52Week High', to: '/weekhigh_stock' },
        { name: '52Week Low', to: '/weeklow_stock' },
        { name: 'DD', to: '/drawdown_changes' },
        // { name: 'Result Impact', to: '/strategies_res' },
        { name: 'Approach High', to: '/strategies_duration' },
        // { name: 'Notifications', to: '/notification' },
        { name: 'watchlist', to: '/watchlist' },
        { name: 'Candle Pattern', to: '/candle_pattern' },
        { name: 'Harmonic Pattern', to: '/harmonic_pattern' },
        { name: 'HighOI', to: '/highoi' },
        // { name: 'Vol Blast', to: '/vol_blast' },
        
        { name: 'Pre/Market', to: '/premarket_top_gl' },



      ],
    },
    {
      name: 'F&O',
      to: '/f_o_dashboard',
      subheader: [
        { name: 'F&O Stocks', to: '/f_o_dashboard' },
        { name: 'Stock Details', to: '/f_o_listdata' },
        { name: 'Industry', to: '/f_o_industry_score' },
        { name: 'Blast', to: '/highvolume' },
        { name: 'Guided', to:'/guided_data'},
        { name: '', to: '/vol_blast' },
        {}
      ],
    },
    // { name: 'Index', 
    //   to: '/index' 
    // },
    {
      name: 'Index', to: '/options',
    },
    {
      name: 'Options', to: '/stock_timeseries', // Changed this to the default route
      subheader: [
        // {name:'Dashboard', to: '/stock_timeseries'},
        { name: 'Dashboard', to: '/trendingstock' },
        { name: 'Options Details', to: '/stock_options' },
        { name: 'Stock Rank', to: '/stock_rank' },
        { name: 'Rank Change', to: '/rank_change' },
        { name: 'Momentum', to: '/momentum_stock' },
        { name: 'Vol Blast', to: '/volume_blast_intraday' },
        { name: 'Trade Log', to: '/tradelog' },



      ],
    },


    {
      name: 'Strategy',
      to: '/f_o_watchlist'
    },
    {
      name: 'Portfolio',
      to: '/portfolio',
      subheader: [
        { name: 'Dashboard', to: '/portfolio' },
        { name: 'Holdings', to: '/portfolio/holdings' },
        { name: 'Positions', to: '/portfolio/positions' },
        { name: 'Orders', to: '/portfolio/orders' },
        { name: 'Tracking', to: '/portfolio/tracking' }
      ]
    },
    // { name: 'Pullback', 
    //   to: '/pullback' 
    // },

    // {
    //   name: 'Alert',
    //   to: '/alert_stock',


    {
      name: 'Query',
      to: '/filter-with-query',
    },
    {
      name: 'Data Tools',
      to: '/data-tools/kite-fetch',
      subheader: [
        { name: 'Fetch from Kite', to: '/data-tools/kite-fetch' },
        { name: 'Add Excel Sheet', to: '/data-tools/excel-sheet' },
        { name: 'Advanced Query',  to: '/data-tools/advanced-query' },
      ],
    },
    {
      name: 'ATM',
      to: '/index_atm_dashboard'
    },
  ];

  // Update active states based on current route
  useEffect(() => {
    const currentPath = location.pathname;

    // if (currentPath === '/') {
    //   setActiveHeader(null);
    //   setActiveSubheader(null);
    //   return;
    // }
    for (const item of mainNavItems) {
      if (item.subheader) {
        const matchingSubheader = item.subheader.find(sub => sub.to === currentPath);
        if (matchingSubheader) {
          setActiveHeader(item.name);
          setActiveSubheader(matchingSubheader.name);
          return;
        }
      }
      // Check main header path
      if (item.to === currentPath) {
        setActiveHeader(item.name);
        setActiveSubheader(null);
        return;
      }
    }
  }, [location.pathname]);

  const handleHeaderClick = (event, headerName, hasSubheader, itemTo) => {
    if (hasSubheader) {
      event.preventDefault();

      // Special case for Options - navigate to default page and show subheader
      if (headerName === 'Options') {
        navigate('/trendingstock');
        setActiveHeader(headerName);
        setActiveSubheader('Dashboard'); // Set the default active subheader
      }
      else if (headerName === 'Stocks') {
        navigate('/');
        setActiveHeader(headerName);
        setActiveSubheader('Top Gainers Losers'); // Set the default active subheader
      }
      else if (headerName === 'Portfolio') {
        navigate('/portfolio');
        setActiveHeader(headerName);
        setActiveSubheader('Dashboard'); // Set the default active subheader
      }
      else if (headerName === 'Heat Map') {
        navigate('/sector_heatmap');
        setActiveHeader(headerName);
        setActiveSubheader('Industry');
      }
      else if (headerName === 'Data Tools') {
        navigate('/data-tools/kite-fetch');
        setActiveHeader(headerName);
        setActiveSubheader('Fetch from Kite');
      }
      else {
        // For other headers with subheaders, just toggle the dropdown
        setActiveHeader(headerName === activeHeader ? null : headerName);
      }
    }
  };

  // Style for notification bell
  const notificationButtonStyle = {
    marginLeft: 'auto',

    backgroundColor: 'floralwhite',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    padding: '8px',
    marginRight: '0%',
    borderRadius: '50%',
    transition: 'background-color 0.2s'
  };

  return (
    <header className="header">
      <div className="header-container">
        <Link
          to="/card"
          className="logo-link"
          onClick={() => {
            setActiveHeader(null);
            setActiveSubheader(null);
          }}
        >
          <img src={logo} alt="Logo" className="header-logo" />
        </Link>

        <nav className="main-nav">
          <ul className="nav-list">
            {mainNavItems.map((item) => (
              <li
                key={item.name}
                className={`nav-item ${activeHeader === item.name ? 'active' : ''}`}
              >
                <Link
                  to={item.to}
                  className={`nav-link ${activeHeader === item.name ? 'active' : ''}`}
                  onClick={(e) => handleHeaderClick(e, item.name, !!item.subheader, item.to)}
                >
                  {item.name}
                  <span className="link-underline"></span>
                </Link>
              </li>
            ))}
          </ul>
        </nav>
        <SearchComponent />
        {/* Notification bell button */}
        <button
          style={notificationButtonStyle}
          onClick={() => setShowAlertPopup(true)}
          title="Create Price Alert"
        >
          <Bell size={22} color="#333" />
        </button>
        {/* Fullscreen toggle button */}
        <button
          style={{ ...notificationButtonStyle, marginLeft: '8px' }}
          onClick={toggleFullscreen}
          title={isFullscreen ? 'Exit Fullscreen' : 'Enter Fullscreen'}
        >
          {isFullscreen ? <Minimize size={22} color="#333" /> : <Maximize size={22} color="#333" />}
        </button>

      </div>

      {activeHeader && mainNavItems.find((item) => item.name === activeHeader)?.subheader && (
        <div className="subheader-container">
          <ul className="subheader-list">
            {mainNavItems
              .find((item) => item.name === activeHeader)
              ?.subheader?.map((subItem) => (
                <li key={subItem.name} className="subheader-item">
                  <Link
                    to={subItem.to}
                    className={`subheader-link ${activeSubheader === subItem.name ? 'active' : ''
                      }`}
                  >
                    {subItem.name}
                  </Link>
                </li>
              ))}
          </ul>
        </div>

      )}
      {/* Price Alert Popup */}

      <PriceAlertPopup
        isOpen={showAlertPopup}
        onClose={() => setShowAlertPopup(false)}
      />
    </header>
  );
};

export default Header;
